export class KUxBaseEventData {
  // @ts-expect-error TODO Fix
  groupId: number;
  /**
   * User ID, provided only if the user is a registered user
   */
  userId?: number;
  /**
   * Household ID, provided only if the user is a registered user
   */
  hhId?: number;
  /**
   * Device’s UDID
   */
  // @ts-expect-error TODO Fix
  udid: string;
  /**
   * Device family ID. From pre-defined list of device families
   */
  deviceFamily?: string;
  /**
   * Device brand ID. From pre-defined list of device Brands
   */
  deviceBrand?: string;
  /**
   * Device manufacturer ID. From pre-defined list of manufacturers defined for the account
   */
  deviceManufacturer?: string | null;
  /**
   * provided only if the device is registered
   */
  /**
   * Based on the device internal model
   */
  deviceModel?: string;
  /**
   * Current OS name
   */
  osName?: string;
  /**
   * Current OS version
   */
  osVersion?: string;
  /**
   * Current firmware
   */
  firmware?: string | null;
  /**
   * GMT based timestamp of when the event is fired, in seconds
   */
  timestamp?: number;
  /**
   * Kaltura ks, for current user or anonymous ks
   */
  // @ts-expect-error TODO Fix
  ks: string;
  /**
   * External Key - the purpose of the External Key is to provide a security layer for external systems that consumes the device events.
   * More details can be found in NTVM-3759
   */
  externalKey?: string;
  /**
   * Version of the events ingest API
   */
  apiVersion?: string;

  constructor(data: KUxBaseEventData) {
    if (!data?.deviceManufacturer) data.deviceManufacturer = null;
    if (!data?.firmware) data.firmware = null;
    Object.assign(this, data);
  }
}

export class BaseEventArgs {
  path?: string;
  timestamp?: number;

  constructor(path: string) {
    this.path = path;
  }
}

export class KuxEventWithParam extends BaseEventArgs {
  param1?: string;
  param2?: string;
  param3?: string;

  constructor(path: string, data?: Partial<KuxEventWithParam>) {
    super(path);
    Object.assign(this, data);
  }
}
